import { classNames } from 'libs/react';
import { Icon } from 'components/Icon';
import { Link } from 'components/Link';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './TabBarButton.scss';
/**
 * @component TabBarButton
 * @since 1.0.0
 */
export function TabBarButton(props) {
    const { route, style, picto, label, badge, selected, disabled } = Object.assign({ style: 'normal', selected: false, disabled: false }, props);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick() {
        if (disabled) {
            return;
        }
        if (props.onPress) {
            props.onPress();
        }
    }
    const className = classNames('tab-bar-button', 'tab-bar-button--' + style, { 'tab-bar-button--is-selected': selected }, { 'tab-bar-button--is-disabled': disabled }, { 'tab-bar-button--has-label': label }, { 'tab-bar-button--has-picto': picto }, props.className);
    const content = (React.createElement(React.Fragment, null,
        picto && React.createElement(Icon, { className: "tab-bar-button-picto", value: picto }),
        label && React.createElement(Text, { className: "tab-bar-button-label", value: label }),
        badge && React.createElement(Icon, { className: "tab-bar-button-badge", value: badge })));
    if (route) {
        return (React.createElement(Link, { className: className, route: route }, content));
    }
    return (React.createElement("button", { type: "button", role: "tab", "aria-selected": selected, title: typeof label == 'string' ? label : undefined, className: className, disabled: disabled, onClick: onClick, onFocus: props.onFocus, onBlur: props.onBlur }, content));
}
